export enum TransactionType {
  None = 0,
  Deposit = 1,
  Withdrawal = 2,
  Payout = 3,
  TokenSale = 4
}
